import React from 'react';
import { Button } from '@common/components/button';

const getScaleButtonClasses = (isSelected: boolean, isDisabled?: boolean) => {
  const baseClasses =
    '!tw-p-2 !tw-rounded-lg !tw-w-8 !tw-h-8 !tw-font-medium !tw-text-base !tw-mr-0';
  return `${baseClasses} ${
    isSelected
      ? '!tw-text-white'
      : '!tw-text-gray-textGray !tw-bg-gray-neutral-50'
  } ${isDisabled ? '!tw-cursor-not-allowed' : ''}`;
};

const ScaleButtonsRow = ({
  scales,
  selectedScaleId,
  selectedScale,
  fallbackLabel,
  onSelect,
  disabled,
}: {
  scales: any[];
  selectedScaleId?: string;
  selectedScale?: any;
  fallbackLabel: string;
  onSelect: (scaleId: string) => void;
  disabled?: boolean;
}) => (
  <div className="tw-flex tw-flex-row tw-items-center tw-gap-3">
    <div className="tw-flex tw-flex-row tw-items-center tw-gap-1">
      {scales.map((scale, idx) => {
        const isSelected = String(scale.id) === String(selectedScaleId);
        return (
          <Button
            key={scale.id}
            size="small"
            className={getScaleButtonClasses(isSelected, disabled)}
            style={
              isSelected && scale?.color
                ? {
                    backgroundColor: scale.color,
                    color: '#FFFFFF',
                  }
                : undefined
            }
            onClick={() => onSelect(String(scale.id))}
            disabled={disabled}
          >
            {idx + 1}
          </Button>
        );
      })}
    </div>

    <div className="tw-w-[1px] tw-h-4 tw-flex tw-flex-col tw-bg-gray-border" />

    <div className="tw-text-gray-text tw-text-base tw-font-medium">
      {selectedScale ? selectedScale.label : fallbackLabel}
    </div>
  </div>
);

export default ScaleButtonsRow;
